import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Logger from '../services/loggerService';
import { type RootState } from '../services/serviceTypes';

/**
 * Custom hook that provides a function to format messages with fallback to intl.
 */
const useLocalization = () => {
  const intl = useIntl();

  // Try to get messages from Redux, but provide a fallback for tests
  let messages: Record<string, unknown> = {};

  try {
    const result = useSelector((state: RootState) => state.user);

    messages = result.messages || {};
  } catch (error) {
    // In test environments without Redux provider, this will catch the error
    Logger.warn('Redux store not found, using empty messages object');
  }

  return (
    messageId: string,
    defaultMessage = '',
    values?: Record<string, string | number | boolean | Date | null | undefined>
  ): string => {
    const message = messages[messageId];

    if (message && typeof message === 'string') {
      return message;
    }

    return intl.formatMessage(
      {
        id: messageId,
        defaultMessage,
      },
      values
    );
  };
};

export default useLocalization;
